import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { countryPhoneCodes } from "utils/constants";

import FormValidation from "./FormValidation";
import UserScheduleBooking from "./UserScheduleBooking";

function RegistrationForm({
  index,
  formValues,
  handleFormInput,
  isRegistrationFormValid,
  ticket,
  onScheduleSelect,
  availableSchedules,
  invalidEmailFormat,
}) {
  const { t } = useTranslation();

  // remove duplicate codes
  const newCountryPhoneCodes = countryPhoneCodes.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.code === value.code),
  );

  return (
    <div className="grid grid-cols-1 sm:grid-cols-6 gap-x-8 gap-y-4">
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel12")}
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer_uuid-${index}`]}
            placeholder={t("contactFormPlaceholder8")}
            type="text"
            name={`customer_uuid-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel1")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-name-${index}`]}
            placeholder={t("contactFormPlaceholder1")}
            type="text"
            name={`customer-name-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            value={formValues[`customer-name-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel2")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-email-${index}`]}
            placeholder={t("contactFormPlaceholder2")}
            type="text"
            name={`customer-email-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            value={formValues[`customer-email-${index}`]}
            showError={!isRegistrationFormValid || invalidEmailFormat}
            errorMsg={
              invalidEmailFormat ? "Please enter a valid email format." : ""
            }
            specialCase={invalidEmailFormat}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel7")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          {/* <select onChange={handleFormInput} value={formValues[`customer-phcode-${index}`]} name={`customer-phcode-${index}`} className='px-2 text-sm font-bold outline-none select-none w-fit'>
            <option value='' selected></option>
            {newCountryPhoneCodes.sort((a, b) => a.code - b.code).map(((country) => (
              <option value={country.code}>{country.code}</option>
            )))}
          </select> */}
          <span>+</span>(
          <input
            type="number"
            onChange={handleFormInput}
            value={formValues[`customer-phcode-${index}`]}
            name={`customer-phcode-${index}`}
            className="w-8 text-sm font-bold text-center outline-none select-none"
          />
          <span>)</span>
          <input
            onChange={handleFormInput}
            value={formValues[`phone-number-${index}`]}
            name={`phone-number-${index}`}
            placeholder={t("contactFormPlaceholder7")}
            type="number"
            min="0"
            className="block w-full pl-2 text-gray-900 border-0 outline-none placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />
        </div>
        <FormValidation
          value={
            formValues[`phone-number-${index}`] &&
            formValues[`customer-phcode-${index}`]
          }
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel3")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`company-name-${index}`]}
            placeholder={t("contactFormPlaceholder3")}
            type="text"
            name={`company-name-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            value={formValues[`company-name-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel4")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-division-${index}`]}
            placeholder={t("contactFormPlaceholder4")}
            type="text"
            name={`customer-division-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            value={formValues[`customer-division-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      {/* <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel6")}
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`id-number-${index}`]}
            placeholder={t("contactFormPlaceholder6")}
            type="number"
            name={`id-number-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div> */}

      {ticket &&
      ticket.webinar_type &&
      ticket.webinar_type === "Consultation" ? (
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {t("contactFormLabel10")} *
          </label>
          <div className="relative mt-1">
            <select
              onChange={handleFormInput}
              value={formValues[`discussion_topic-${index}`] || ""}
              name={`discussion_topic-${index}`}
              className="block w-full p-2 pr-10 text-gray-900 border-0 rounded-md shadow-sm appearance-none ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option
                value=""
                disabled
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {t("contactFormPlaceholder10")}
              </option>
              <option value="ESG">ESG</option>
              <option value="CSR">CSR</option>
              <option value="Community Development">
                Community Development
              </option>
              <option value="Social Entrepreneurship">
                Social Entrepreneurship
              </option>
              <option value="Sustainability">Sustainability</option>
              <option value="Entrepreneurship">Entrepreneurship</option>
              <option value="Leadership">Leadership</option>
              <option value="ESG Governance">ESG Governance</option>
              <option value="ESG Risk and Opportunity Assessment">
                ESG Risk and Opportunity Assessment
              </option>
              <option value="Double Materiality">Double Materiality</option>
              <option value="ESG Ratings and Indexes">
                ESG Ratings and Indexes
              </option>
              <option value="ESG Disclosure standards">
                ESG Disclosure standards
              </option>
            </select>

            {/* Custom dropdown arrow */}
            <div className="absolute inset-y-0 flex items-center pointer-events-none right-2">
              <svg
                className="w-4 h-4 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
          <FormValidation
            value={formValues[`discussion_topic-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      ) : null}

      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel8")}
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`referral-code-${index}`]}
            placeholder={t("contactFormPlaceholder8")}
            type="text"
            name={`referral-code-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel9")}
        </label>
        <div className="mt-1">
          <textarea
            rows={5}
            onChange={handleFormInput}
            value={formValues[`notes-${index}`]}
            placeholder={t("contactFormPlaceholder9")}
            type="text"
            name={`notes-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
    </div>
  );
}

export default RegistrationForm;
